export default "__VITE_ASSET__Bds8Qah7__"